import {useMemo} from "react";
import type {GroupRepo, ItemId, RecipeId} from "../../models/GroupRepo";

// Which recipes use each item. Only counts recipes that still exist, as deleting a recipe leaves
// its ingredient rows behind.
export const useRecipeIdsByItemId = (groupRepo: GroupRepo) => {
  const ingredients = groupRepo.Ingredients.useGetAll();
  const recipes = groupRepo.Recipes.useGetAll();
  return useMemo(() => {
    const map = new Map<ItemId, Set<RecipeId>>();
    for (const {itemId, recipeId} of Object.values(ingredients)) {
      if (!Object.hasOwn(recipes, recipeId)) continue;
      let recipeIds = map.get(itemId);
      if (!recipeIds) map.set(itemId, (recipeIds = new Set()));
      recipeIds.add(recipeId);
    }
    return map;
  }, [ingredients, recipes]);
};
